<template>
  <!-- TAB WRAP//S -->
  <div class="tab-wrap">
    <vs-tabs vs-alignment="fixed">
      <vs-tab label="KRW 마켓">
        <!-- KRW TAB//S -->
        <ul class="main-list krw" :class="{loadActive : loadList, loadEnd : loadEnd}">
          <li v-for="(coin, index) in coins" :key="index" :class="{active : coin.active}">
            <router-link to="/trade/" class="default">
              <p class="coin-name">
                {{coin.name}}
                <span>({{coin.code}})</span>
              </p>
              <p class="coin-price">
                13,202,000
                <span>KRW</span>
              </p>
              <p class="coin-percent">
                <span v-if="index!=2 && index!=1" class="txt-red">
                  <i class="material-icons icon-final">arrow_drop_up</i>
                  7.68%
                </span>
                <span v-else class="txt-blue">
                  <i class="material-icons icon-final">arrow_drop_down</i>
                  11.02%
                </span>
              </p>
              <p class="favorite" :class="{active: coin.favorite}" @click.prevent="coin.favorite = !coin.favorite"></p>
              <p class="more" :class="{active: coin.active}" @click.prevent="coin.active = !coin.active"></p>
            </router-link>
            <div class="add-info">
              <div>
                <p class="tit">평가금액 (KRW)</p>
                <p class="price">123,456,789</p>
              </div>
              <div>
                <p class="tit">평가손익 (KRW)</p>
                <p class="percent">
                  <span v-if="index!=2 && index!=1" class="txt-red">
                    <i class="material-icons icon-final">arrow_drop_up</i>
                    7.68% (+1,234,567)
                  </span>
                  <span v-else class="txt-blue">
                    <i class="material-icons icon-final">arrow_drop_down</i>
                    11.02% (+1,234,567)
                  </span>
                </p>
              </div>
            </div>
          </li>
        </ul>
        <!-- KRW TAB//E -->
      </vs-tab>
      <vs-tab label="BTC 마켓">
        <!-- BTC TAB//S -->
        <ul class="main-list">
          <li v-for="(coin, index) in coins" :key="index" :class="{active : coin.active}">
            <router-link to="/trade/" class="default">
              <p class="coin-name">
                {{coin.name}}
                <span>({{coin.code}})</span>
              </p>
              <p class="coin-price">
                13,202,000
                <span>KRW</span>
              </p>
              <p class="coin-percent">
                <span v-if="index!=2 && index!=1" class="txt-red">
                  <i class="material-icons icon-final">arrow_drop_up</i>
                  7.68%
                </span>
                <span v-else class="txt-blue">
                  <i class="material-icons icon-final">arrow_drop_down</i>
                  11.02%
                </span>
              </p>
              <p class="favorite" :class="{active: coin.favorite}" @click="coin.favorite = !coin.favorite"></p>
              <p class="more" :class="{active: coin.active}" @click="coin.active = !coin.active"></p>
            </router-link>
            <div class="add-info">
              <div>
                <p class="tit">평가금액 (KRW)</p>
                <p class="price">123,456,789</p>
              </div>
              <div>
                <p class="tit">평가손익 (KRW)</p>
                <p class="percent">
                  <span v-if="index!=2 && index!=1" class="txt-red">
                    <i class="material-icons icon-final">arrow_drop_up</i>
                    7.68% (+1,234,567)
                  </span>
                  <span v-else class="txt-blue">
                    <i class="material-icons icon-final">arrow_drop_down</i>
                    11.02% (+1,234,567)
                  </span>
                </p>
              </div>
            </div>
          </li>
        </ul>
        <!-- BTC TAB//E -->
      </vs-tab>
      <vs-tab label="ETH 마켓">
        <!-- ETH TAB//S -->
        <ul class="main-list">
          <li v-for="(coin, index) in coins" :key="index" :class="{active : coin.active}">
            <router-link to="/trade/" class="default">
              <p class="coin-name">
                {{coin.name}}
                <span>({{coin.code}})</span>
              </p>
              <p class="coin-price">
                13,202,000
                <span>KRW</span>
              </p>
              <p class="coin-percent">
                <span v-if="index!=2 && index!=1" class="txt-red">
                  <i class="material-icons icon-final">arrow_drop_up</i>
                  7.68%
                </span>
                <span v-else class="txt-blue">
                  <i class="material-icons icon-final">arrow_drop_down</i>
                  11.02%
                </span>
              </p>
              <p class="favorite" :class="{active: coin.favorite}" @click="coin.favorite = !coin.favorite"></p>
              <p class="more" :class="{active: coin.active}" @click="coin.active = !coin.active"></p>
            </router-link>
            <div class="add-info">
              <div>
                <p class="tit">평가금액 (KRW)</p>
                <p class="price">123,456,789</p>
              </div>
              <div>
                <p class="tit">평가손익 (KRW)</p>
                <p class="percent">
                  <span v-if="index!=2 && index!=1" class="txt-red">
                    <i class="material-icons icon-final">arrow_drop_up</i>
                    7.68% (+1,234,567)
                  </span>
                  <span v-else class="txt-blue">
                    <i class="material-icons icon-final">arrow_drop_down</i>
                    11.02% (+1,234,567)
                  </span>
                </p>
              </div>
            </div>
          </li>
        </ul>
        <!-- ETH TAB//E -->
      </vs-tab>
    </vs-tabs>
  </div>
  <!-- TAB WRAP//E -->
</template>
<script>
export default {
  data () {
    return {
      refresh: false,
      loadList: false,
      loadEnd: false,
      coins:[{
        name: '비트코인',
        code: 'BTC',
        favorite: false,
        active: false
      }, {
        name: '비트코인캐시',
        code: 'BCH',
        favorite: false,
        active: false
      }, {
        name: '이더리움',
        code: 'ETH',
        favorite: false,
        active: false
      }, {
        name: '이더리움클래식',
        code: 'ETC',
        favorite: false,
        active: false
      }, {
        name: '리플',
        code: 'XRP',
        favorite: false,
        active: false
      }, {
        name: '모네로',
        code: 'XMR',
        favorite: false,
        active: false
      }, {
        name: '라이트코인',
        code: 'LTC',
        favorite: false,
        active: false
      }, {
        name: '퀀텀',
        code: 'QTUM',
        favorite: false,
        active: false
      }, {
        name: '덴트',
        code: 'DENT',
        favorite: false,
        active: false
      }]
    }
  },
  mounted() {
    this.motionTimer();
  },
  methods: {
    swipeHandler(direction) {
      const el = document.scrollingElement || document.documentElement;
      if(el.scrollTop > 0) return
      this.refresh = true;
      setTimeout(function(){
        location.reload()
      }, 1500);
    },
    motionTimer() {
      setTimeout(
        _ => this.loadList = true,
        300
      );
      setTimeout(
        _ => (this.loadList = false, this.loadEnd = true),
        1500
      );
    }
  }
};
</script>
<style>
</style>
